


















    import AbpBase from "@/lib/abpbase"
    import {Component} from "vue-property-decorator"
    import AddOrEdit from './parts/addOrEdit.vue'
    import {QueryDeleteSysDic, QuerySysDic} from "@/api/material"

    @Component({
        components: {AddOrEdit}
    })
    export default class MaterialClass extends AbpBase {
        addOrEditShow = false
        addOrEditData: any = {}
        query = {
            typeName: '',
            status: true,
            dataType: 2 // 物资分类
        }

        created() {
            this.getData()
        }

        addOne() {
            this.addOrEditData = {
                mode: 'add',
            }
            this.addOrEditShow = true
        }

        columns = [
            {
                title: '编号',
                key: 'code'
            },
            {
                title: '分类名称',
                key: 'typeName'
            },
            {
                title: '所属类型编号',
                key: 'pCode'
            },
            {
                title: '所属类型名称',
                key: 'pTypeName'
            },
            {
                title: '状态',
                render: (h: any, p: any) => {
                    return h('span', p.row.isActive)
                }
            },
            {
                title: '操作',
                width: 190,
                render: (h: any, p: any) => {
                    return h('div', [
                        h('el-button', {
                            props: {type: 'text'},
                            on: {
                                click: () => {
                                    this.editOne(p)
                                }
                            }
                        }, '编辑'),
                        // h('el-button', {
                        //     props: {type: 'error'},
                        //     on: {
                        //         click:async ()=>{
                        //             this.$confirm('确认要删除吗？',{
                        //                 confirmButtonText:this.L('Yes'),
                        //                 cancelButtonText:this.L('No')})
                        //                 .then(async () => {
                        //                     let res = await QueryDeleteSysDic({id:p.row.id})
                        //                     this.getData()
                        //                 })
                        //                 .catch(() => {
						//
                        //                 });
                        //         }
                        //     }
                        // }, '删除'),
                    ])
                }
            }
        ]
        data = []

        async getData() {
            let res = await QuerySysDic(this.query)
            this.data = res.data
        }

        private editOne(p:any) {
            this.addOrEditData = {
                mode: 'edit',
                data: p.row
            }
            this.addOrEditShow = true
        }
    }
